module.exports = "<div class=\"article-element theme-bg1\" [routerLink]=\"['/' + publication.id + '/articles/' + article.id ]\">\n  <h1 class=\"article-title theme-header\">{{article.title}}</h1>\n  <div class=\"article-type\">{{article.article_type}}</div>\n  <div class=\"bg-image\" *ngIf=\"article?.img?.article_image\">\n    <img [src]=\"'http://46.22.221.22:3001/' + article?.img?.article_image\">\n  </div>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/article-card/article-card.component.html
// module id = 204
// module chunks = 1